// © 2026 Orpyx Medical Technologies Inc.

import {PropertyNamePipe} from "orpyx-web-common";
import {Field, useFormikContext} from "formik";
import {Select} from "formik-material-ui";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as React from "react";
import {memo} from "react";
import {PrimaryConcernSelectorProps} from "./primary-concern-selector.interface";
import {PatientSubmitCareNoteFormValues} from "../patient-submit-care-note-form/patient-submit-care-note-form.interface";

export const PrimaryConcernSelector = memo((props: PrimaryConcernSelectorProps) => {
    const {errors, touched} = useFormikContext<PatientSubmitCareNoteFormValues>();

    const fieldName = PropertyNamePipe(props.values, 'primaryConcernId');
    const inputProps = {
        id: fieldName,
        name: fieldName
    };

    //  formik-material-ui's Select drops error / helperText, unlike its TextField, so the
    //  surrounding FormControl carries the error state and the message instead.
    const showError = Boolean(touched.primaryConcernId && errors.primaryConcernId);

    return (
        <FormControl error={showError} fullWidth={true}>
            <Field
                component={Select}
                className={props.classes.input}
                name={fieldName}
                value={props.selectedConcern}
                inputProps={inputProps}
            >
                {props.concerns.map(concern => (<MenuItem key={concern.id} value={concern.id}>
                    {concern.name}
                </MenuItem>))}
            </Field>

            {showError && <FormHelperText>
                {errors.primaryConcernId}
            </FormHelperText>}
        </FormControl>
    );
});
